import Top from './topComponent';
import TopSecond from './topSecond';
import Footer from './footer';
import Navbar from './navbar';




export  const TopCom = () => <Top/>
export const TopSecondCom = () => <TopSecond/>
export const NavbarCom =()=><Navbar/>
export const FooterCom= () =><Footer/>
